import styled from 'styled-components';

export const PageMore = styled.span`
  display: inline-block;
  position: relative;
  top: -3px;
  color: ${({ theme }) => theme.colors.fontL};
`;
